import React from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import heroImg from "../../assets/about_us/heroimg1.png";
import proto from "../../assets/about_us/Anima video.mp4";
import x1 from "../../assets/about_us/vec3.png";
import x12 from "../../assets/about_us/vec1.png";
import x13 from "../../assets/about_us/vec2.png";

export default function AboutUsComponent() {
  const objectivesData = [
    {
      id: 1,
      image: x12,
      title: "100,000 + Users",
      description:
        "Achieve a user base of over 100,000 within the first year by delivering secure, seamless financial services across Sri Lanka.",
    },
    {
      id: 2,
      image: x13,
      title: "500+ Partnerships",
      description:
        "Build collaborations with over 500 business organizations to expand integration and payment reach.",
    },
    {
      id: 3,
      image: x1,
      title: "LKR 70 Million+ Transactions Processed",
      description:
        "Facilitate transactions exceeding LKR 70 million in the first year, ensuring speed, trust, and reliability for all users.",
    },
  ];

  return (
    <Box
      sx={{
        bgcolor: "black",
        color: "white",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* ---------------- HERO SECTION ---------------- */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: "1400px",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 2, sm: 4, md: 8 },
          py: { xs: 6, md: 10 },
          gap: { xs: 4, md: 8 },
        }}
      >
        {/* Blue Glow Background */}
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "-20%",
            left: 0,
            background:
              "radial-gradient(50% 50% at 50% 0%, rgba(94,176,239,0.5) 0%, rgba(255,255,255,0) 100%)",
            zIndex: 0,
          }}
        />

        {/* Hero Image */}
        <Box
          component="img"
          src={heroImg}
          alt="Hero"
          sx={{
            width: { xs: "85%", sm: "70%", md: "45%" },
            maxWidth: 600,
            objectFit: "contain",
            zIndex: 1,
          }}
        />

        {/* Text Content */}
        <Stack
          spacing={3}
          sx={{
            width: { xs: "100%", md: "50%" },
            textAlign: { xs: "center", md: "left" },
            alignItems: { xs: "center", md: "flex-start" },
            zIndex: 2,
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "36px", sm: "48px", md: "64px" },
              lineHeight: { xs: "48px", sm: "64px", md: "80px" },
              letterSpacing: "3px",
              background:
                "linear-gradient(176deg, rgba(255,255,255,1) 0%, rgba(113,113,122,1) 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Who We Are?
          </Typography>

          <Typography
            sx={{
              fontWeight: 500,
              color: "#a1a1aa",
              fontSize: { xs: "16px", sm: "18px", md: "20px" },
              lineHeight: "32px",
              textAlign: "justify",
              maxWidth: "600px",
            }}
          >
            MoiPay is a cutting-edge all-in-one fintech mobile application with a mission to empower
            Sri Lankans worldwide. Our app combines technology, innovation, and security to deliver
            seamless, secure, and user-friendly financial solutions.
          </Typography>

          <Button
                    variant="contained"
          
          
          
            onClick={() => {
              document
                .getElementById("download-section")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
          
          
          
          
                    sx={{
                      width:"190px",
                      height:"40px",
                      bgcolor: "#09090b",
                      borderRadius: "9999px",
                      px: 2,
                      py: 2.5,
                      color:" #A1A1AA",
                      fontSize: 20,
                      fontWeight: 500,
                      lineHeight: "20px",
                      textTransform: "none",
                      boxShadow: "0px 0px 0px 0.2px #22D3E0",
                      "&:hover": { bgcolor: "#18181b" },
                    }}
                  >
                    Download Now
                  </Button>
        </Stack>
      </Box>

      {/* ---------------- ALL FEATURES ---------------- */}
      <Box sx={{ textAlign: "center", py: { xs: 6, md: 10 }, px: 2, width: "100%" }}>
        <Typography
          sx={{
            background:
              "linear-gradient(177deg, rgba(255,255,255,1) 0%, rgba(113,113,122,1) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: 700,
            fontSize: { xs: "32px", sm: "40px", md: "48px" },
            letterSpacing: "2.4px",
            mb: 3,
          }}
        >
          All the Features in One App
        </Typography>

        <Box
          sx={{
            width: { xs: "95%", sm: "85%", md: "70%" },
            mx: "auto",
            borderRadius: "20px",
            overflow: "hidden",
          }}
        >
          <video
            src={proto}
            autoPlay
            loop
            muted
            playsInline
            style={{ width: "100%", height: "auto", display: "block" }}
          />
        </Box>
      </Box>

      {/* ---------------- MISSION & VISION ---------------- */}
      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 4,
          py: { xs: 6, md: 10 },
          px: { xs: 3, md: 0 },
          alignItems: "stretch",
          justifyContent: "center",
        }}
      >
        {["Our Mission", "Our Vision"].map((heading, idx) => (
          <Box
            key={idx}
            sx={{
              flex: 1,
              minWidth: 280,
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: 28, md: 32 },
                fontWeight: 700,
                mb: 2,
                background:
                  "linear-gradient(177deg, rgba(255,255,255,1) 0%, rgba(113,113,122,1) 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {heading}
            </Typography>
            <Box
              sx={{
                bgcolor: "rgba(255,255,255,0.06)",
                borderRadius: 3,
                p: { xs: 3, md: 4 },
                height: "100%",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: 16, md: 18 },
                  lineHeight: "28px",
                  textAlign: "justify",
                }}
              >
                {heading === "Our Mission"
                  ? "At MoiPay, our mission is simple — to make digital payments effortless, secure, and accessible to everyone. We're here to empower people and businesses with smarter financial solutions while simplifying daily transactions."
                  : "To become the leading digital payment solution provider, enabling efficient financial transactions for individuals and businesses globally."}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>

      {/* ---------------- OBJECTIVES SECTION ---------------- */}
      <Box sx={{ width: "100%", py: { xs: 6, md: 10 }, textAlign: "center" }}>
        <Typography
          sx={{
            background:
              "linear-gradient(177deg, rgba(255,255,255,1) 0%, rgba(113,113,122,1) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: 700,
            fontSize: { xs: "32px", sm: "40px", md: "48px" },
            letterSpacing: "2.4px",
            mb: 6,
          }}
        >
          Objectives
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 6, sm: 4, md: 8 }}
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          sx={{ px: 2 }}
        >
          {objectivesData.map((objective) => (
            <Box
              key={objective.id}
              sx={{
                width: { xs: "90%", sm: 300, md: 345 },
                minHeight: 299,
                borderRadius: 3,
                overflow: "hidden",
                boxShadow: "0px 10px 20px rgba(0,0,0,0.3)",
                bgcolor: "#fff",
                p: 3,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 20,
                  color: "black",
                  mb: 2,
                }}
              >
                {objective.title}
              </Typography>

              <Box
                component="img"
                src={objective.image}
                alt={objective.title}
                sx={{ width: 50, height: 50, objectFit: "contain", opacity: 10 }}
              />

              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 16,
                  color: "black",
                  mt: 2,
                  lineHeight: "24px",
                }}
              >
                {objective.description}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}


